const chunkMapping = {
	"webpack_container_remote_CHECKOUT_HcpSlice-webpack_container_remote_CHECKOUT_addressSlice": [
		77867,
		98328
	],
	"src_bootstrap_js-src_assets_images_loader_gif-node_modules_pure-react-carousel_dist_react-car-afe45b": [
		68266,
		94468,
		32307,
		12594,
		85206,
		77216,
		99601,
		24253,
		48152,
		16422,
		78972,
		21228,
		17240,
		73882,
		20729,
		87949,
		9598,
		22756,
		76208,
		93421,
		16792,
		2813,
		86908,
		55077,
		42413,
		10497,
		84090,
		79144,
		66318,
		73913,
		72463,
		55169,
		93527,
		82013,
		15089,
		93894,
		75021
	],
	"src_components_PersonalizeMessageOption_index_js": [
		28602
	],
	"src_components_SearchResults_index_js": [
		61953
	],
	"src_components_ItemDetails_index_js": [
		94324
	],
	"src_components_MarketingMaterial_index_js": [
		78119
	],
	"src_components_ECheckOut_index_js": [
		32866
	],
	"src_components_TemplateDetail_index_js": [
		53075
	],
	"src_components_EmailDetail_index_js": [
		94044
	],
	"src_components_CheckOut_index_js": [
		97911
	],
	"src_components_OrderDetail_index_js": [
		99129
	],
	"src_components_TemplateSetup_index_js": [
		78464
	],
	"src_components_ManageStateShipWith_index_js": [
		37339
	],
	"src_components_Cart_index_js": [
		66227
	],
	"src_components_Collections_CreateCollection_index_js": [
		71198
	],
	"src_components_Collections_ModifyCollection_index_js": [
		87124
	],
	"src_components_Collections_index_js": [
		99103
	],
	"src_components_UserProfile_index_js": [
		30452
	],
	"src_components_SalesTeam_index_js": [
		14121
	],
	"src_components_AttributeSalesTeam_index_js": [
		36841
	],
	"src_components_OrderSearch_index_js": [
		32430
	],
	"src_components_shippingType_index_js": [
		41520
	],
	"src_components_UserRole_AllUserRoles_index_js": [
		6497
	],
	"src_components_UserRole_UserRoleDetail_index_js": [
		91326
	],
	"src_components_UserRole_CreateUserRole_index_js": [
		37073
	],
	"src_components_EmailManagement_index_js": [
		11396
	],
	"src_components_Account_index_js": [
		33209
	],
	"src_components_ProductDisplay_index_js": [
		26000
	],
	"src_components_UserSearch_index_js": [
		96276
	],
	"src_components_CreateUser_index_js": [
		76001
	],
	"src_components_ShipMethods_shipToHcp_js": [
		8736
	],
	"src_components_ShipMethods_shipToSite_js": [
		3702
	],
	"src_components_ShipMethods_shipToColleague_js": [
		99560
	],
	"src_components_ShipMethods_customizedResourceSharing_js": [
		52905
	],
	"src_components_ShipMethods_HcpCustomFeature_js": [
		89651
	],
	"src_components_AllocationEditsComp_index_js": [
		78452
	],
	"src_components_ShipMethods_ShipToDistribution_js": [
		13117
	],
	"src_components_OrderDetailComp_index_js": [
		12053
	],
	"src_components_Support_index_js": [
		27017
	],
	"src_components_ValidForUse_index_js": [
		6876
	],
	"src_components_ViewAllTemplates_index_js": [
		44511
	],
	"src_components_SiteAdministration_index_js": [
		16862
	],
	"src_components_AddNewMessage_index_js": [
		39606
	],
	"src_components_AddressBook_index_js": [
		43345
	],
	"src_components_AddressBook_AddressBookCreateEdit_js": [
		38348
	],
	"src_components_ShippingMethodsAssignment_index_js": [
		46157
	],
	"webpack_container_remote_ItemDetails_CustomizeTemplates": [
		33057
	]
};
const idToExternalAndNameMapping = {
	"2813": [
		"default",
		"./trialAllocationApi",
		79943
	],
	"3702": [
		"default",
		"./ShipToSite",
		51127
	],
	"6497": [
		"default",
		"./UserRole",
		28935
	],
	"6876": [
		"default",
		"./ReportsComp",
		28935
	],
	"8736": [
		"default",
		"./ShipToHcp",
		51127
	],
	"9598": [
		"default",
		"./customResourceSharingApi",
		79943
	],
	"10497": [
		"default",
		"./announcementSlice",
		28935
	],
	"11396": [
		"default",
		"./EmailManagementComp",
		28935
	],
	"12053": [
		"default",
		"./OrderDetailInfo",
		51127
	],
	"12594": [
		"default",
		"./Hcp360Slice",
		51127
	],
	"13117": [
		"default",
		"./ShipToDistribution",
		51127
	],
	"14121": [
		"default",
		"./SalesTeamIndex",
		28935
	],
	"15089": [
		"default",
		"./userAllocationApi",
		28935
	],
	"16422": [
		"default",
		"./collectionApi",
		93875
	],
	"16792": [
		"default",
		"./templateDetailSlice",
		79943
	],
	"16862": [
		"default",
		"./SiteAdministrationComp",
		28935
	],
	"17240": [
		"default",
		"./cartSlice",
		83623
	],
	"20729": [
		"default",
		"./FooterComp",
		23217
	],
	"21228": [
		"default",
		"./api",
		83623
	],
	"22756": [
		"default",
		"./customResourceSharingSlice",
		79943
	],
	"24253": [
		"default",
		"./shipToDistributionSlice",
		51127
	],
	"26000": [
		"default",
		"./ProductDisplayComp",
		28935
	],
	"27017": [
		"default",
		"./Support",
		28935
	],
	"28602": [
		"default",
		"./PersonalizeMessageOption",
		51127
	],
	"30452": [
		"default",
		"./UserProfileIndex",
		28935
	],
	"32307": [
		"default",
		"./ColleagueSlice",
		51127
	],
	"32430": [
		"default",
		"./OrderSearch",
		51127
	],
	"32866": [
		"default",
		"./ECheckoutComp",
		51127
	],
	"33057": [
		"default",
		"./CustomizeTemplates",
		79943
	],
	"33209": [
		"default",
		"./Account",
		28935
	],
	"36841": [
		"default",
		"./AttributeSalesTeamIndex",
		28935
	],
	"37073": [
		"default",
		"./UserRoleCreate",
		28935
	],
	"37339": [
		"default",
		"./ManageStateShipWithComp",
		28935
	],
	"38348": [
		"default",
		"./AddressBookCreateEdit",
		34199
	],
	"39606": [
		"default",
		"./AddStandardMessages",
		28935
	],
	"41520": [
		"default",
		"./ShippingType",
		51127
	],
	"42413": [
		"default",
		"./SalesTeamSliceIndex",
		28935
	],
	"43345": [
		"default",
		"./AddressBookComp",
		34199
	],
	"44511": [
		"default",
		"./ViewAllTemplatesComp",
		79943
	],
	"46157": [
		"default",
		"./ShippingMethodsAssignmentIndex",
		28935
	],
	"48152": [
		"default",
		"./shipToSiteSlice",
		51127
	],
	"52905": [
		"default",
		"./CustomizedResourceSharingComp",
		79943
	],
	"53075": [
		"default",
		"./TemplateDetailComp",
		79943
	],
	"55077": [
		"default",
		"./ReportsSlice",
		28935
	],
	"55169": [
		"default",
		"./supportSlice",
		28935
	],
	"61953": [
		"default",
		"./SearchResultsComp",
		34875
	],
	"66227": [
		"default",
		"./CartComp",
		83623
	],
	"66318": [
		"default",
		"./messagesSlice",
		28935
	],
	"68266": [
		"default",
		"./AddressBookSlice",
		34199
	],
	"71198": [
		"default",
		"./CreateCollection",
		93875
	],
	"72463": [
		"default",
		"./searchSliceUser",
		28935
	],
	"73882": [
		"default",
		"./orderSlice",
		83623
	],
	"73913": [
		"default",
		"./product",
		28935
	],
	"75021": [
		"default",
		"./userSearch",
		28935
	],
	"76001": [
		"default",
		"./CreateUser",
		28935
	],
	"76208": [
		"default",
		"./hcpSearchApi",
		79943
	],
	"77216": [
		"default",
		"./orderSearchSlice",
		51127
	],
	"77867": [
		"default",
		"./HcpSlice",
		51127
	],
	"78119": [
		"default",
		"./MarketingMaterialComp",
		79943
	],
	"78452": [
		"default",
		"./AllocationEditsComp",
		28935
	],
	"78464": [
		"default",
		"./TemplateSetupComp",
		28935
	],
	"78972": [
		"default",
		"./collectionSlice",
		93875
	],
	"79144": [
		"default",
		"./messagesApi",
		28935
	],
	"82013": [
		"default",
		"./user",
		28935
	],
	"84090": [
		"default",
		"./emailSlice",
		28935
	],
	"85206": [
		"default",
		"./ShippingTypeSlice",
		51127
	],
	"86908": [
		"default",
		"./SearchSlice",
		34875
	],
	"87124": [
		"default",
		"./CollectionModify",
		93875
	],
	"87949": [
		"default",
		"./HeaderComp",
		60365
	],
	"89651": [
		"default",
		"./HcpCustomFeatures",
		51127
	],
	"91326": [
		"default",
		"./UserRoleDetail",
		28935
	],
	"93421": [
		"default",
		"./itemDetailSlice",
		79943
	],
	"93527": [
		"default",
		"./trialAllocationApiUser",
		28935
	],
	"93894": [
		"default",
		"./userProfileSlice",
		28935
	],
	"94044": [
		"default",
		"./EmailDetailsComp",
		79943
	],
	"94324": [
		"default",
		"./ItemDetailComp",
		79943
	],
	"94468": [
		"default",
		"./CheckoutSlice",
		51127
	],
	"96276": [
		"default",
		"./UserSearchComp",
		28935
	],
	"97911": [
		"default",
		"./CheckoutComp",
		51127
	],
	"98328": [
		"default",
		"./addressSlice",
		51127
	],
	"99103": [
		"default",
		"./CollectionComp",
		93875
	],
	"99129": [
		"default",
		"./OrderDetail",
		51127
	],
	"99560": [
		"default",
		"./ShipToColleague",
		51127
	],
	"99601": [
		"default",
		"./personalizeMessageSlice",
		51127
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}